/* ============================================================
 * SleepHappy Top-Bar Marquee — F-15 (2026-04-26)
 *
 * Replaces Halo's <hdt-slider> fade-rotation with a horizontal
 * continuous-scroll marquee in the top announcement bar.
 *
 * Behavior:
 * - Finds the existing <hdt-slider> in .hdt-top-bar
 * - Removes the custom-element wrapper so Halo's slider JS no
 *   longer manipulates the transform / opacity of the slides
 * - Clones the slide list once so the animation can loop by
 *   translating exactly -50% (seamless wrap)
 * - Tags the container with `.sh-marquee-active` so the matching
 *   CSS in sh-installment-suite.css takes over visual layout +
 *   keyframe animation
 *
 * CSS counterpart: assets/sh-installment-suite.css (F-15 block)
 * Triggered by: layout/theme.liquid <script src="...">
 * Pauses on hover via CSS animation-play-state.
 * Honors prefers-reduced-motion via the CSS @media block.
 * ============================================================ */
(function () {
  'use strict';

  var setupAttempted = false;

  function findContainer() {
    return document.querySelector('.hdt-top-bar .hdt-top-bar-text__slider .hdt-slider__container');
  }

  /* F-37 (2026-04-26): Per-locale text override for top-bar slides.
     San reported: "ผมเปลี่ยนเป็น Ver. En ไม่เห็นเปลี่ยนตามเลย"
     Hardcoded TH text in header-group.json (text_nfpxGM block) doesn't
     go through Translate & Adapt (no | t filter), so /en/ pages still
     showed Thai. We swap text in-DOM BEFORE cloning, so the marquee
     animates EN content from the first frame.
     Map keys must match the slides' innerHTML byte-for-byte (verified
     against live DOM 2026-04-26 — see design-decisions-log F-37). */
  var TH_TO_EN_SLIDES = {
    'PAYDAY SUMMER ลดสูงสุด 60%': 'PAYDAY SUMMER UP TO 60% OFF',
    '🚚 ส่งฟรีทั่วประเทศ · ผ่อน 0% นาน 10 เดือน': '🚚 Free Shipping Nationwide · 0% Interest 10 Months',
    '🛡️ รับประกันโครงสร้าง 10 ปี': '🛡️ 10-Year Structural Warranty'
  };

  function localizeSlides(slides) {
    var locale = (document.documentElement.lang || 'th').toLowerCase().slice(0, 2);
    if (locale !== 'en') return;
    Array.prototype.forEach.call(slides, function (slide) {
      for (var thKey in TH_TO_EN_SLIDES) {
        if (slide.innerHTML.indexOf(thKey) !== -1) {
          slide.innerHTML = slide.innerHTML.replace(thKey, TH_TO_EN_SLIDES[thKey]);
          break; /* each slide has one TH text — exit after first match */
        }
      }
    });
  }

  function setupMarquee() {
    if (setupAttempted) return true;
    var slider = document.querySelector('.hdt-top-bar .hdt-top-bar-text__slider');
    if (!slider) return false;
    var container = slider.querySelector('.hdt-slider__container');
    if (!container) return false;
    var slides = container.querySelectorAll('.hdt-slider__slide');
    if (!slides.length) return false;

    setupAttempted = true;

    /* Step 1 — disconnect Halo's slider custom element by replacing
       <hdt-slider> with a plain <div>. Custom-element disconnectedCallback
       fires automatically; Halo no longer schedules transform updates. */
    var replacement = document.createElement('div');
    replacement.className = (slider.className || '') + ' sh-mq-wrap';
    /* Preserve any data attributes other code may rely on */
    Array.prototype.forEach.call(slider.attributes, function (attr) {
      if (attr.name === 'class') return;
      try { replacement.setAttribute(attr.name, attr.value); } catch (e) {}
    });
    replacement.innerHTML = slider.innerHTML;
    slider.parentNode.replaceChild(replacement, slider);

    /* Re-find container/slides inside the replacement */
    container = replacement.querySelector('.hdt-slider__container');
    slides = container.querySelectorAll('.hdt-slider__slide');

    /* F-37 — localize slide text. No-op when locale === 'th'. */
    localizeSlides(slides);

    /* F-43 v2 (2026-04-26): JS-driven fade rotation (replaces F-15
       horizontal scroll). One slide visible at a time, rotates every 4s.
       Uses element.style.setProperty(..., 'important') to override F-15's
       `opacity: 1 !important` and other layout rules cleanly. */
    setupFadeRotation(container, slides);

    /* Flag the container so F-36 visibility-hide releases */
    container.classList.add('sh-marquee-active');

    return true;
  }

  function setStyle(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function setupFadeRotation(container, slides) {
    /* Override F-15 container layout via inline !important */
    setStyle(container, 'animation', 'none');
    setStyle(container, 'display', 'block');
    setStyle(container, 'width', '100%');
    setStyle(container, 'position', 'relative');
    setStyle(container, 'height', '24px');
    setStyle(container, 'gap', '0');
    setStyle(container, 'flex-wrap', 'initial');

    /* Apply absolute positioning + opacity transition to each slide */
    Array.prototype.forEach.call(slides, function (slide, i) {
      setStyle(slide, 'position', 'absolute');
      setStyle(slide, 'top', '50%');
      setStyle(slide, 'left', '50%');
      setStyle(slide, 'transform', 'translate(-50%, -50%)');
      setStyle(slide, 'transition', 'opacity 0.5s ease-in-out');
      setStyle(slide, 'opacity', i === 0 ? '1' : '0');
      setStyle(slide, 'white-space', 'nowrap');
      setStyle(slide, 'display', 'inline-flex');
      setStyle(slide, 'align-items', 'center');
      setStyle(slide, 'width', 'auto');
      setStyle(slide, 'flex', '0 0 auto');
    });

    if (slides.length < 2) return; /* only one slide → no rotation needed */

    /* Rotate every 4 seconds */
    var current = 0;
    setInterval(function () {
      setStyle(slides[current], 'opacity', '0');
      current = (current + 1) % slides.length;
      setStyle(slides[current], 'opacity', '1');
    }, 4000);
  }

  /* F-205 v2 (2026-05-02): revealTopBar adds .is-ready class to .hdt-top-bar.
     Top bar is hidden by inline CSS in top-bar.liquid until this fires.
     Idempotent — safe to call multiple times. */
  function revealTopBar() {
    var topBar = document.querySelector('.hdt-top-bar');
    if (topBar && !topBar.classList.contains('is-ready')) {
      topBar.classList.add('is-ready');
    }
  }

  /* F-205 v2 — GLOBAL SAFETY: guaranteed reveal at 3s regardless of state
     (font load failure, marquee setup error, JS exception, iOS Safari quirks).
     Without this, top bar could stay permanently hidden if main path fails. */
  setTimeout(revealTopBar, 3000);

  /* Halo may initialize <hdt-slider> after DOMContentLoaded. Retry a
     few times until both the element and its inner slides exist.
     F-205 v2: revealTopBar() called INSIDE attempt() ONLY after setupMarquee
     actually succeeds — user never sees pre-setup state (TH text on /en/
     before localizeSlides swap). */
  var attempts = 0;
  function attempt() {
    if (setupMarquee()) {
      revealTopBar();
      return;
    }
    if (++attempts < 50) {
      setTimeout(attempt, 100);
    } else {
      /* Fallback after 5s of retries: reveal anyway so top bar isn't
         permanently hidden. Halo's original slider takes over visually. */
      var fallback = findContainer();
      if (fallback) fallback.classList.add('sh-marquee-active');
      revealTopBar();
    }
  }

  /* F-204 (2026-05-02): Wait for fonts before marquee init.
     Combined with font-display: block in sh-fonts.css.liquid, this ensures
     the marquee fade-in animation runs ONLY after Prompt is loaded —
     eliminating the FOUT race condition where the .sh-marquee-active
     fade-in (180ms) could overlap with font swap, making the system→Prompt
     swap visible mid-fade. With this gate, fade-in starts AFTER fonts ready
     so user sees Prompt from frame 1.
     2.5s timeout safety: if fonts.ready never resolves (rare — font load
     failure), proceed anyway so the top bar isn't permanently hidden. */
  function startMarqueeWhenFontsReady() {
    /* F-204 + F-205 v2: Wait for fonts ready (or 2.5s timeout) before init.
       Combined with hide-until-ready in top-bar.liquid, reveal happens AFTER
       setupMarquee → localizeSlides → fade rotation are all complete with
       Prompt loaded. The 3s setTimeout(revealTopBar) above guarantees safety. */
    var fontReady = (document.fonts && document.fonts.ready)
      ? document.fonts.ready
      : Promise.resolve();
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 2500); });
    Promise.race([fontReady, timeout]).then(function () {
      try { attempt(); } catch (e) { /* swallow — 3s safety reveal will fire */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMarqueeWhenFontsReady, { once: true });
  } else {
    startMarqueeWhenFontsReady();
  }

  /* F-38 (2026-04-26): Tag the parent of .sh-top-utility with class
     .sh-top-utility-wrap so the mobile-hide CSS rule can target it
     WITHOUT relying on :has() (which fails on older mobile browsers
     like LINE in-app webview + iOS Safari <15.4).
     Runs separately from marquee setup since utility links are
     server-rendered and present from initial HTML parse. */
  function tagUtilityWrap() {
    var ul = document.querySelector('.sh-top-utility');
    if (!ul) return;
    var parent = ul.closest('.hdt-top-bar__custom-liquid') || ul.parentElement;
    if (parent) parent.classList.add('sh-top-utility-wrap');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagUtilityWrap, { once: true });
  } else {
    tagUtilityWrap();
  }

  /* ============================================================
   * F-18 → F-20 (2026-04-26): TH/EN pill language toggle
   * Inserts the pill into the header icons row (.hdt-site-top_nav)
   * just before the search icon, per San:
   *   "เปลี่ยนภาษาย้ายมาอยู่ข้างๆแว่นขยาย"
   * Pill style — ACTIVE = navy circle / WHITE text,
   *              INACTIVE = light beige pill / muted text.
   * (Header background is white so the on-navy variant from F-18
   * doesn't apply anymore — see .sh-lang-toggle--header in CSS.)
   * ============================================================ */
  function setupLangToggle() {
    /* Idempotency guards per surface */
    var headerDone = !!document.querySelector('.sh-lang-toggle--header');
    var mobileDone = !!document.querySelector('.sh-lang-toggle--mobile');
    if (headerDone && mobileDone) return true;

    var currentLocale = (document.documentElement.lang || 'th').toLowerCase().slice(0, 2);
    var path = location.pathname;
    var isEnPath = /^\/en(\/|$)/.test(path);
    var thHref = isEnPath ? (path.replace(/^\/en/, '') || '/') : path;
    var enHref = isEnPath ? path : '/en' + path;

    /* Preserve query string + hash so the user lands on the same view
       in the other language. */
    var suffix = location.search + location.hash;
    thHref += suffix;
    enHref += suffix;

    function buildPillsHTML() {
      return (
        '<a href="' + thHref + '" class="sh-lang-pill' + (currentLocale === 'th' ? ' is-active' : '') + '" data-locale="th" aria-label="ภาษาไทย">TH</a>' +
        '<a href="' + enHref + '" class="sh-lang-pill' + (currentLocale === 'en' ? ' is-active' : '') + '" data-locale="en" aria-label="English">EN</a>'
      );
    }

    /* ── Desktop header ── before search icon in .hdt-site-top_nav ── */
    if (!headerDone) {
      var iconsRow = document.querySelector('.hdt-site-top_nav.hdt-flex.hdt-justify-end');
      if (iconsRow && iconsRow.firstElementChild) {
        var headerWrap = document.createElement('div');
        /* Match Halo's icon-row child shape so spacing/alignment Just Works */
        headerWrap.className = 'hdt-site-nav_icon sh-lang-toggle sh-lang-toggle--header hdt-inline-flex hdt-align-center';
        headerWrap.innerHTML = buildPillsHTML();
        iconsRow.insertBefore(headerWrap, iconsRow.firstElementChild);
        headerDone = true;
        /* F-22: apply mobile-only behavior right after header mount —
           don't gate on full setup (mobile drawer may not exist on every page). */
        applyMobileLangSwitch();
      }
    }

    /* ── Mobile menu drawer ── replace Halo's "ภาษาไทย ▼" dropdown
       inside the hamburger panel with the same pill toggle. The
       wrapper element is .hdt-mb-language_currencies — drop our pill
       inline and clear out the original button (and its popover trigger). */
    if (!mobileDone) {
      var mobileWrap = document.querySelector('.hdt-mobile_bottom .hdt-mb-language_currencies, .hdt-mb-language_currencies');
      if (mobileWrap) {
        var mobileInner = document.createElement('div');
        mobileInner.className = 'sh-lang-toggle sh-lang-toggle--mobile';
        mobileInner.innerHTML = buildPillsHTML();
        /* Wipe Halo's localization form/buttons; keep wrapper for layout */
        mobileWrap.innerHTML = '';
        mobileWrap.appendChild(mobileInner);
        mobileDone = true;
      }
    }

    return headerDone && mobileDone;
  }

  /* 2026-05-26: Swap active pill's href → alternate-locale URL on ALL viewports.
     Inactive pill is hidden via CSS — so the single visible pill becomes a toggle
     that switches language on click. (Previously gated to ≤767px only — Boss
     extended to desktop on 2026-05-26.) */
  function applyMobileLangSwitch() {
    var hdr = document.querySelector('.sh-lang-toggle--header');
    if (!hdr) return;
    var active = hdr.querySelector('.sh-lang-pill.is-active');
    var inactive = hdr.querySelector('.sh-lang-pill:not(.is-active)');
    if (!active || !inactive) return;
    if (!active.hasAttribute('data-orig-href')) {
      active.setAttribute('data-orig-href', active.getAttribute('href') || '');
    }
    active.setAttribute('href', inactive.getAttribute('href'));
    active.setAttribute('aria-label',
      active.getAttribute('data-locale') === 'th'
        ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย');
  }

  var langAttempts = 0;
  function attemptLang() {
    if (setupLangToggle()) { applyMobileLangSwitch(); return; }
    if (++langAttempts < 50) setTimeout(attemptLang, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptLang, { once: true });
  } else {
    attemptLang();
  }
})();
